import { isPostSpam } from "@repo/fika-shared/src/lib/spam-condition"
import { type FragmentOf, graphql, readFragment } from "@/graphql"
import { useI18nContext } from "@/i18n/i18n-solid"
import type { Pill } from "./pills"

export const PostStatusPillFragment = graphql(`
  fragment PostStatusPillFragment on Post {
    updatedAt
    publishedAt
    archivedAt
    sentAt
    spamScore
  }
`)

export function postStatusPill(
  post: FragmentOf<typeof PostStatusPillFragment>,
): Pill {
  const unmaskedPost = readFragment(PostStatusPillFragment, post)
  const { LL } = useI18nContext()

  if (!unmaskedPost) {
    return {
      icon: "pencil",
      label: LL().blog.filter.draft(),
      rounded: true,
      hue: "sand",
    }
  }

  if (isPostSpam({ spam_score: unmaskedPost.spamScore })) {
    return {
      icon: "shield-alert",
      label: LL().blog.filter.spam(),
      rounded: true,
      hue: "rose",
    }
  }

  if (unmaskedPost.archivedAt) {
    return {
      icon: "archive",
      label: LL().blog.filter.archived(),
      rounded: true,
      hue: "orange",
    }
  }

  if (unmaskedPost.sentAt) {
    return {
      icon: "send",
      label: LL().blog.filter.sent(),
      rounded: true,
      hue: "indigo",
    }
  }

  if (unmaskedPost.publishedAt) {
    return {
      icon: "book-up",
      label: LL().blog.filter.published(),
      rounded: true,
      hue: "emerald",
    }
  }

  return {
    icon: "pencil",
    label: LL().blog.filter.draft(),
    rounded: true,
    hue: "sand",
  }
}
